import types from '../../../mutation-types';

export const setPageFilter = ({ dispatch, filter, page, markEndReached }) => {
  dispatch('conversationPage/setCurrentPage', { filter, page }, { root: true });
  if (markEndReached) {
    dispatch('conversationPage/setEndReached', { filter }, { root: true });
  }
};

export const setContacts = (commit, chatList) => {
  commit(
    `contacts/${types.SET_CONTACTS}`,
    chatList.map(chat => chat.meta.sender)
  );
};

export const isOnMentionsView = ({ route: { name: routeName } }) => {
  const MENTION_ROUTES = [
    'conversation_mentions',
    'conversation_through_mentions',
  ];
  return MENTION_ROUTES.includes(routeName);
};

export const isOnUnattendedView = ({ route: { name: routeName } }) => {
  const UNATTENDED_ROUTES = [
    'conversation_unattended',
    'conversation_through_unattended',
  ];
  return UNATTENDED_ROUTES.includes(routeName);
};

export const isOnFoldersView = ({ route: { name: routeName } }) => {
  const FOLDER_ROUTES = [
    'folder_conversations',
    'conversations_through_folders',
  ];
  return FOLDER_ROUTES.includes(routeName);
};

export const preserveInFlightLabels = (conversation, rootGetters) => {
  const shouldIgnore =
    rootGetters?.['conversationLabels/shouldIgnoreIncomingLabels'];
  if (!conversation || typeof shouldIgnore !== 'function') return conversation;

  if (!shouldIgnore(conversation.id, conversation.updated_at)) {
    return conversation;
  }

  return {
    ...conversation,
    labels: rootGetters['conversationLabels/getActiveLabelTitles'](
      conversation.id
    ),
  };
};

export const buildConversationList = (
  context,
  requestPayload,
  responseData,
  filterType
) => {
  const { payload: rawConversationList, meta: metaData } = responseData;
  const keywordFilterApplied = requestPayload?.queryData?.payload?.some(
    filter => filter.attribute_key === 'content'
  );
  const conversationList = rawConversationList.map(conversation => {
    const next = preserveInFlightLabels(conversation, context.rootGetters);
    if (!keywordFilterApplied) return next;

    return { ...next, matched_by_filter: true };
  });
  context.commit(types.SET_ALL_CONVERSATION, conversationList);
  context.dispatch('conversationStats/set', metaData);
  context.dispatch(
    'conversationLabels/setBulkConversationLabels',
    conversationList
  );
  context.commit(types.CLEAR_LIST_LOADING_STATUS);
  setContacts(context.commit, conversationList);
  setPageFilter({
    dispatch: context.dispatch,
    filter: filterType,
    page: requestPayload.page,
    markEndReached: !conversationList.length,
  });
};
